import { PlusOutlined } from '@ant-design/icons';
import { Button, Col } from 'antd';
import React, { useState } from 'react';
import ListDocument from './ListDocument';
import DocumentDetails from './DocumentDetails';
import DeleteDocument from './DeleteDocument';
import { isAuthorizedRole } from '@seims/shared/src/security';


export default function DocumentView({ }) {

    const isUploader = isAuthorizedRole(["DOCUMENT_REPO_UPLOADER", "ADMIN"]);
    const isRatifer = isAuthorizedRole(["DOCUMENT_REPO_RATIFIER", "ADMIN"]);
    const defaultTitle = "Management";

    const [visible, setVisible] = useState(false);
    const [hasUpdated, setHasUpdated] = useState(true);
    const [modalType, setModalType] = useState("add/Upload");

    const [mainTitle, setMainTitle] = useState(defaultTitle);

    const showModal = (record, type) => {
        setVisible(record);
        setModalType(type)
    };

    return (
        <>
            <div className="content" key={"main-div"}>
                <Col xs={24}>
                    <h1 className="center-align">{"Document Repository - " + mainTitle}</h1>
                </Col>
                {isUploader && (
                    <Button
                        className="add-button"
                        key="Button-1"
                        type="primary"
                        onClick={() => showModal({}, "add/Upload")}
                        icon={<PlusOutlined />}
                    >
                       {" "} Upload Document
                    </Button>
                )}
                {(modalType !== "delete" ) && (
                    <DocumentDetails
                        key={"DocumentDetails-1"}
                        type={modalType}
                        setType={setModalType}
                        record={visible}
                        onShow={showModal}
                        hasUpdated={hasUpdated}
                        setHasUpdated={setHasUpdated}
                    />
                )}
                {(modalType === "delete") && (
                    <DeleteDocument
                        key={"DeleteDocument-1"}
                        record={visible}
                        onShow={showModal}
                        hasUpdated={hasUpdated}
                        setHasUpdated={setHasUpdated}
                        modalType={modalType}
                    />
                )}
                <ListDocument
                    key={"ListDocument-1"}
                    hasUpdated={hasUpdated}
                    setHasUpdated={setHasUpdated}
                    modalType={modalType}
                    setModalType={setModalType}
                    showModal={showModal}
                    isUploader={isUploader}
                    isRatifer={isRatifer}
                    setMainTitle={setMainTitle}
                    defaultTitle={defaultTitle}
                />
            </div>
        </>
    );
}
